import axios from "axios";
import { ENDPOINT } from "../ENDPOINT";
import { UserService } from "./UserService";

export const QuotationService = {

  getAllQuotation: async () => {
    try {
      const response = await axios.get(ENDPOINT.quotation);
      return response.data;
    } catch (error) {
      console.error("Error fetching quotation:", error.message);
      throw error;
    }
  },

  getAllQotationProjects: async () => {
    try {
      const user = await UserService.getOmeUser();
      const response = await axios.get(`${ENDPOINT.quotation}/project/${user.uid}`);
      return response.data;
    } catch (error) {
      console.error("Error fetching quotation:", error.message);
      throw error;
    }
  },

  getAllQuotationByUID: async (id) => {
    try {
      const response = await axios.get(`${ENDPOINT.quotationByUser}/${id}`);
      return response.data;
    } catch (error) {
      console.error("Error fetching quotation:", error.message);
      throw error;
    }
  },

  getAllQuotationById: async (id) => {
    try {
      const response = await axios.get(`${ENDPOINT.quotation}/${id}`);
      return response.data;
    } catch (error) {
      console.error("Error fetching quotation:", error.message);
      throw error;
    }
  },

  getEqCustomerByQId: async (id) => {
    try {
      const response = await axios.get(`${ENDPOINT.quotation}/eq/${id}`);
      return response.data;
    } catch (error) {
      console.error("Error fetching quotation:", error.message);
      throw error;
    }
  },

   getAllQuotationLast: async () => {
    try {
      const response = await axios.get(`${ENDPOINT.quotation}/last`);
      return response.data;
    } catch (error) {
      console.error("Error fetching quotation:", error.message);
      throw error;
    }
  },

  createQuotation: async (data) => {
    try {
      const response = await axios.post(ENDPOINT.quotation, data,
        {
          headers: {
            "Content-Type": "application/json",
          },
        });
      return response.data;
    } catch (error) {
      console.error("Error fetching quotation:", error.message);
      throw error;
    }
  },


  updateQuotation: async (data, id) => {
    try {
      const response = await axios.put(`${ENDPOINT.quotation}/update/${id}`, data,
        {
          headers: {
            "Content-Type": "application/json",
          },
        });
      return response.data;
    } catch (error) {
      console.error("Error fetching quotation:", error.message);
      throw error;
    }
  },

   patchQuotation: async (data, id) => {
    try {
      const response = await axios.patch(`${ENDPOINT.quotation}/${id}`, data,
        {
          headers: {
            "Content-Type": "application/json",
          },
        });
      return response.data;
    } catch (error) {
      console.error("Error fetching quotation:", error.message);
      throw error;
    }
  },

  getDigitalSign: async () => {
    try {
      const response = await axios.get(`${ENDPOINT.getAllDgSignDb}`);
      return response.data;
    } catch (error) {
      console.error("Error fetching quotation:", error.message);
      throw error;
    }
  },


  deleteQuotation: async ( id) => {
    try {
      const response = await axios.delete(`${ENDPOINT.quotation}/${id}`);
      return response.data;
    } catch (error) {
      console.error("Error fetching quotation:", error.message);
      throw error;
    }
  },


};
